export const apiendpoint = "https://api.spotify.com/v1";
export const sdkpath = "https://sdk.scdn.co/spotify-player.js";
